import { gql } from '../../__generated__/gql'

export const REACTIVATE_SUBSCRIPTION_MUTATION = gql(`
  mutation reactivateSubscriptionPlan {
    reactivateSubscriptionPlan(input: {}) {
      user {
        ...userProfileFields
      }
    }
  }
`)
